import React from "react";
import { SummaryWrapper, Text } from "./styles";
import Video from "./video";
import { ComponentWrapper, Container } from "../styles";
import useAppLogic from "../../../hooks/use-app-logic";
import { LocaleValue } from "../../../types";
import { useApp } from "../../../state/app";
import Mp4Video from "../../video/mp4Video";

type Props = {
  backgroundColor?: string;
  text: LocaleValue;
  video: string;
  subtitle?: string;
  audioDescriptionVideo?: string;
  debriefSceneId: string;
};

export default function Summary({
  audioDescriptionVideo,
  backgroundColor,
  text,
  video,
  subtitle = "",
  debriefSceneId,
}: Props) {
  const [src, setSrc] = React.useState<string>(video);
  const audioDescription = useApp((state) => state.audioDescription);
  const { language } = useAppLogic();

  React.useEffect(() => {
    if (!audioDescriptionVideo) return;
    setSrc(audioDescription ? audioDescriptionVideo : video);
  }, [audioDescription, audioDescriptionVideo, video]);

  return (
    <Container>
      <SummaryWrapper>
        <ComponentWrapper $backgroundColor={backgroundColor}>
          <Text dangerouslySetInnerHTML={{ __html: text?.[language] ?? "" }} />
          <Mp4Video
            audioDescriptionVideo={src}
            skippableVideo={false}
            videoSrc={src}
            subtitle={subtitle}
            sceneId={debriefSceneId}
          />
        </ComponentWrapper>
      </SummaryWrapper>
    </Container>
  );
}

// <Video videoSrc={src} subtitle={subtitle} />
